import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login.component';
import { ForgotPasswordRequestComponent } from "./forgot-password-request/forgot-password-request.component";

const routes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'forgot-password-request', component: ForgotPasswordRequestComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LoginRoutingModule { }
